import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ReportsService } from '../../../../services/reports.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { saveAs } from 'file-saver';
import { CommonService } from '../../../../services/common.service';


@Component({
    selector: 'app-ldar-fugitive-emission-report',
    imports: [DropdownModule, CommonModule, TableModule, RouterModule, FormsModule, CheckboxModule],
    templateUrl: './ldar-fugitive-emission-report.component.html',
    styleUrl: './ldar-fugitive-emission-report.component.scss'
})
export class LdarFugitiveEmissionReportComponent {

  ldarMissionBuildSearchData: any;
  userCAI: string = '';
  facilityId: string = '';
  reportData: any;
  isShowMainBlock: boolean = false;
  repairtype = [];
  division = [];
  plant = [];
  sections = [];
  plants = [];
  associatedPlants = [];
  isLoading: boolean = false;

  filters:any = {
    userCai: sessionStorage.getItem('currentUser') || '',
    facilityId: localStorage.getItem('current_facility_id') || 'ES',
    division: 'ALL',
    section: 'ALL',
    plant: 'ALL',
    associatedPlants: 'ALL',
    wo: 'All',
    cost: 'All',

  }

  constructor(private report: ReportsService, private router: Router,
    public commonService: CommonService
  ) { 
    this.userCAI = this.commonService.getUserCai()

  }

  ngOnInit() {
    this.facilityId = localStorage.getItem('current_facility_id') || 'ES';
    this.getLDAREmissionbuildSearch(this.facilityId, false);

  }

  getLDAREmissionbuildSearch(facilityId: string, isRetired: boolean): void {
    this.isLoading = true;
    this.report.getLDAREmissionbuildSearch(this.facilityId, isRetired).subscribe(
      (data: any) => {
        this.ldarMissionBuildSearchData = data;
        this.isLoading = false;
        this.repairtype = data.repairTypeItems;
        this.division = data.divisionItems;
        this.sections = data.sectionItems;
        this.plant = data.plantItems;
        this.associatedPlants = data.associatedPlantItems;
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error fetching air compliance details', error);
      }
    );
  }
  //  getLDAREmissionbuildSearch

  runReport() {
    this.isLoading = true;
    this.filters.facilityId = this.facilityId;
    const { division, section, cost, associatedPlants, facilityId } = this.filters;
    this.report.runReportFugitive(
      this.filters
    ).subscribe(
      data => {
        this.reportData = data.TableData.map((d: any) => {

          d.PermanentRepairDate = new Date(d.PermanentRepairDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });

          if (d.PermanentRepairDate)
            d.PermanentRepairDate_color = new Date(d.PermanentRepairDate) < new Date() ? 'red' : 'green';

          return d;
        });

        this.isLoading = false;
        this.isShowMainBlock = true;
        this.router.navigate(['inspection-look-ahead-table/report-component-table']);
      },
      error => {
        this.isLoading = false;
        console.error('Error fetching report data:', error);
      }
    );
  }

exportToExcel() {
    const { division, section, plant, cost, wo } = this.filters;
    let params = {
        facilityID: localStorage.getItem('current_facility_id') || 'ES',
        userCAI: this.userCAI,
        division: division,
        section: section,
        plant: plant,
        cost: cost,
        wo: wo
    };

    this.report.getLDAREmissionbuildSearchExcel(params)
        .subscribe({
            next: (fileData: any) => {
                if (fileData) {
                    saveAs(fileData, 'LDAR Emission Build Report.xlsx');
                }
            },
            error: (err: any) => {
                console.error('Error fetching report details:', err);
            }
        });
}


}
